import styled from 'styled-components/macro';
import media from '../../styles/media';

export const PageContent = styled.main`
  padding: ${({ header }) => (header ? '25px' : '50px')} 15px 25px;
  z-index: 1;
  width: 100%;
  margin: auto;
  ${media.desktop`
    max-width: ${({ size }) => `${size}px`};
    padding-top: 60px;
    padding-bottom: 60px;
  `};

  .NavigationInfo {
    margin-bottom: 15px;
    ${media.desktop`
      margin-bottom: 45px;
    `}
  }

  .Banner {
    margin-bottom: 10px;

    ${media.desktop`
      margin-bottom: 20px;
    `}
  }

  .Section {
    margin-bottom: 10px;

    ${media.desktop`
      margin-bottom: 20px;
    `}
  }
`;
